<script setup lang="ts">
import { computed } from "vue";
import { ch2QuestionLinks } from "~/features/python/ch2/exercise/data/ch2.questions";
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

const props = defineProps<{
  question: Question;
}>();

const conceptLabels: Record<string, string> = {
  variables: "Variables",
  "data-types": "Data Types",
  comments: "Comments",
  "input-output": "Input/Output",
  operators: "Operators",
  expressions: "Expressions",
};

const conceptItems = computed(() =>
  props.question.concepts.map((concept) => ({
    key: concept,
    label: conceptLabels[concept],
    href: ch2QuestionLinks[concept],
  })),
);
</script>

<template>
  <section class="rounded-3xl border border-amber-200 bg-amber-50 p-5 shadow-sm">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-amber-800">Aur samjho</p>
    <h2 class="mt-2 text-lg font-semibold text-slate-900">Agar yeh mushkil lag raha hai to yeh topics kholo:</h2>
    <div class="mt-4 flex snap-x snap-mandatory gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [-ms-overflow-style:none]">
      <NuxtLink
        v-for="item in conceptItems"
        :key="item.key"
        :to="item.href"
        class="snap-start shrink-0 rounded-full bg-white px-3 py-1 text-xs font-medium text-slate-800 ring-1 ring-amber-200"
      >
        {{ item.label }}
      </NuxtLink>
    </div>
  </section>
</template>
